/*
defines appearance of image nodes,
including updating images to reflect an API response
*/

import NodeView from './node';

/**
 * Represents a view for an image node
 */
export default class ImageNodeView extends NodeView {
    /**
     * makes a new image node view given an image node and an optional position
     * @param {ImageNode} node
     * @param {number} [x] (optional) position to start at
     * @param {number} [y] (optional) position to start at
     */
    constructor(node, x = 0, y = 0) {
        super(node, x, y);
        this.type = 'image';

        this.defineImage();
        this.defineUpdateCallback();
        this.image = this.node.image;
        this.cropX, this.cropY, this.cropOuterX, this.cropOuterY;

        this.initTooltip();
    }


    /**
     * defines the function that runs when the api is updated for this node
     */
    defineUpdateCallback() {
        // runs when the API is updated for this node
        this.updateCallback = () => {
            if (this.node.isEmpty()) {
                return;
            }
            let image = this.node.getImage();
            let url = image.url;
            let imageW = image.width ? image.width : this.defaultWidth;
            let imageH = image.height ? image.height : this.defaultHeight;
            let title = this.node.title;

            let h = this.shrunk ? this.defaultHeight * NodeView.shrinkSize : this.height;
            let w = this.shrunk ? this.defaultWidth * NodeView.shrinkSize : this.width;

            this.pattern_selection
                .attr('viewBox', `0 0 ${imageW} ${imageH}`);
            this.image_selection
                .attr('xlink:href', url)
                .attr('width', imageW)
                .attr('height', imageH)
                .attr('title', title);

            this.gnode_selection = NodeView.container.select('.gnode-' + this.id);

            this.selection = this.gnode_selection.select('.node-' + this.id)
                .attr('width', w)
                .attr('height', h)
                .style('transform', `translateX(${this.shrunk ? - this.width / 4 : - this.width / 2}px) translateY(${this.shrunk ? - this.height / 2 : - this.height / 2}px) scale(${this.shrunk ? NodeView.shrinkSize : 1})`);

            this.overlay = this.gnode_selection.append('rect')
                .attr('width', imageW)
                .attr('height', imageH)
                .attr('fill', 'black')
                .style('display', 'none')
                .lower();

            //pushed changes to heroku app; now posting imagenodes to updated heroku app

            // $.post("https://pathways-imgserver.herokuapp.com/control", {url: url});
            // $.post("http://localhost:5000/control", {url: url});
        };
    }

    /**
     * defines the image reference for the given image
     */
    defineImage() {
        NodeView.defs = NodeView.svg.select('#defs');
        if (NodeView.defs.empty()) {
            NodeView.defs = NodeView.svg.append('svg:defs').attr('id', 'defs');
        }

        this.pattern_selection = NodeView.defs
            .append('svg:pattern')
            .attr('id', 'pattern' + this.id)
            .attr('width', 1)
            .attr('height', 1)
            .attr('patternUnits', 'objectBoundingBox');

        let w = this.width;
        let h = this.height;
        let url = this.node.image ? this.node.image.url : '/imgs/looking.png';

        this.image_selection = this.pattern_selection
            .append('svg:image')
            .attr('id', 'pattern' + this.id + 'image')
            .attr('xlink:href', url)
            .attr('width', w)
            .attr('height', h)
            .attr('x', 0)
            .attr('y', 0);
        this.clip_selection = NodeView.defs.append('svg:mask').attr('id', 'clip' + this.id);
        this.clip_selection_2 = this.clip_selection.append('rect')
            .attr('width', 4000)
            .attr('height', 3000)
            .attr('x', -1000)
            .attr('y', -1000)
            .attr('fill', '#222');

        this.clip_selection = this.clip_selection.append('rect')
            .attr('width', w)
            .attr('height', h)
            .attr('x', 0)
            .attr('y', 0)
            .attr('fill', 'white');


        NodeView.clipSelection[this.id] = this.clip_selection;
        this.selection = NodeView.container.select('.node-' + this.id);
    }

    /**
     * returns the type of svg object that this node is represented by
     * @return {SVGElement}
     */
    append() {
        return document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    }

    /**
     * given an id, defines the fill style css
     * @param {number} i id of the image node
     * @return {String}
     */
    fill(i) {
        return `url(#pattern${i})`;
        // return '0';
    }

    /**
     * shows a cropped image
     *
     * @param {Number} x starting position of crop
     * @param {Number} y starting position of crop
     * @param {Number} w width of the crop rectangle
     * @param {Number} h height of the crop rectangle
     * @param {Number} tx translation position of the crop rectangle
     * @param {Number} ty translation position of the crop rectangle
     */
    crop(x, y, w, h, tx, ty) {
        this.clip_selection
            .attr('x', this.cropX = x)
            .attr('y', this.cropY = y)
            .attr('width', w)
            .attr('height', h)
            .attr('transform', 'translate(' + tx + ' ' + ty + ')');

        this.clip_selection_2
            .attr('x', this.cropOuterX = this.x)
            .attr('y', this.cropOuterY = this.y)
            .attr('width', this.width)
            .attr('height', this.height);

        this.overlay
            .attr('x', this.x - this.width/2)
            .attr('y', this.y - this.height/2)
            .attr('width', this.width)
            .attr('height', this.height)
            // .attr('display', 'block')
        this.selection
            .attr('mask', `url(#clip${this.id})`);
    }

    /**
     * hide the crop
     */
    uncrop() {
        this.selection.attr('mask', null);
    }

    /**
     * checks if this image is cropped
     * @return {Boolean}
     */
    isCropped() {
        return !this.selection.empty() && this.selection.attr('mask') !== null && this.selection.attr('mask') !== '';
    }

    /**
     * updates this node's crop position to reflect the new node position
     * (called every frame)
     */
    onTickOne() {
        super.onTickOne();
        if (this.isCropped()) {
            this.clip_selection
                .attr('x', this.cropX += (this.x - this.cropOuterX))
                .attr('y', this.cropY += (this.y - this.cropOuterY));
            this.clip_selection_2
                .attr('x', this.cropOuterX = this.x)
                .attr('y', this.cropOuterY = this.y);
        }

    }
}
